import React from 'react';
import Image from 'next/image';
import styles from './keyfeature.module.scss';
import { Fade } from 'react-awesome-reveal';
import { Typography } from '../Typography';

const KeyMain = ({ data }: any) => {
  // Features data based on Figma design
  const features = [
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 15L17.5 12L14.5 9M9.5 9L6.5 12L9.5 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
            stroke="#CECFD2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Unified Codebase',
      description: 'Write your effect logic once and deploy it anywhere',
    },
    {
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 1V3M14 1V3M8 19V21M14 19V21M19 8H21M19 13H21M1 8H3M1 13H3M7.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19ZM9.6 14H12.4C12.9601 14 13.2401 14 13.454 13.891C13.6422 13.7951 13.7951 13.6422 13.891 13.454C14 13.2401 14 12.9601 14 12.4V9.6C14 9.03995 14 8.75992 13.891 8.54601C13.7951 8.35785 13.6422 8.20487 13.454 8.10899C13.2401 8 12.9601 8 12.4 8H9.6C9.03995 8 8.75992 8 8.54601 8.10899C8.35785 8.20487 8.20487 8.35785 8.10899 8.54601C8 8.75992 8 9.03995 8 9.6V12.4C8 12.9601 8 13.2401 8.10899 13.454C8.20487 13.6422 8.35785 13.7951 8.54601 13.891C8.75992 14 9.03995 14 9.6 14Z"
            stroke="#CECFD2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'GPU Acceleration',
      description: 'Leverage the full power of CUDA, OpenCL, and Metal',
    },
    {
      icon: (
        <svg
          width="20"
          height="22"
          viewBox="0 0 20 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 8C17 11.866 13.866 15 10 15M17 8C17 4.13401 13.866 1 10 1M17 8H3M10 15C6.13401 15 3 11.866 3 8M10 15C11.7509 13.0832 12.7468 10.5956 12.8009 8C12.7468 5.40442 11.7509 2.91685 10 1M10 15C8.2491 13.0832 7.25498 10.5956 7.20091 8C7.25498 5.40442 8.2491 2.91685 10 1M10 15V17M3 8C3 4.13401 6.13401 1 10 1M12 19C12 20.1046 11.1046 21 10 21C8.89543 21 8 20.1046 8 19M12 19C12 17.8954 11.1046 17 10 17M12 19H19M8 19C8 17.8954 8.89543 17 10 17M8 19H1"
            stroke="#CECFD2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Host Compatibility',
      description: 'Automatically generate plugins compatible with OpenFX-based hosts',
    },
    {
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16ZM13 16C10.6131 16 8.32387 15.0518 6.63604 13.364C4.94821 11.6761 4 9.38695 4 7M4 7C5.65685 7 7 5.65685 7 4C7 2.34315 5.65685 1 4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7ZM4 7V19"
            stroke="#CECFD2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: 'Automatic Deployment & Cross-Platform Performance',
      description:
        'Validate, compile, and export plugins that deliver consistent speed and reliability on Windows, macOS, and Linux.',
    },
  ];

  return (
    <div className={styles.featuresContainer}>
      <div className={styles.featuresContent}>
        {/* Header Section */}
        <div className={styles.featuresHeader}>
          <Fade triggerOnce duration={1000}>
            <Typography variant="text-md" color="grayDark-300">
              Features
            </Typography>
          </Fade>

          <Fade triggerOnce duration={1000}>
            <Typography
              variant="display-md"
              as="h2"
              color="grayDark-50"
              weight="semibold"
              className={styles.featuresTitle}
            >
              One Platform, Endless Capabilities
            </Typography>
          </Fade>

          <Fade triggerOnce duration={1000}>
            <Typography variant="text-xl" color="grayDark-400">
              Harness the power of GPU acceleration and a unified codebase to build plugins with
              high speed and compatibility across all platforms.
            </Typography>
          </Fade>
        </div>

        {/* Main Content */}
        <div className={styles.featuresMain}>
          {/* Left Side - Description and Graphic */}
          <div className={styles.featuresLeft}>
            <div className={styles.featuresGraphic}>
              {/* featuresGraphic is display:flex, so next/image's responsive
                  wrapper (which relies on a block-level parent to inherit
                  100% width) needs an explicit-width div here or it collapses
                  to 0 in the flex layout. */}
              <div style={{ width: '100%' }}>
                <Image
                  src="/product-features.jpg"
                  alt="VxFX Video Plugin Development Framework Key Features - Unified Codebase, GPU Acceleration, and Cross-Platform Compatibility"
                  width={1024}
                  height={1024}
                  layout="responsive"
                />
              </div>
            </div>
          </div>

          {/* Right Side - Feature Cards */}
          <div className={styles.featuresRight}>
            <div className={styles.featuresList}>
              {features.map((feature, index) => (
                <Fade key={index} triggerOnce duration={1000} delay={index * 200}>
                  <div className={styles.featureCard}>
                    <div className={styles.featureIcon}>{feature.icon}</div>
                    <div className={styles.featureContent}>
                      <Typography variant="text-lg" as="h3" color="grayDark-50" weight="semibold">
                        {feature.title}
                      </Typography>
                      <Typography variant="text-md" color="grayDark-400">
                        {feature.description}
                      </Typography>
                    </div>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyMain;
